<div>
    <div class="row">
        <div class="col-md-12">
            <div [hidden]="!errorMessage">
				<!--TODO-->
            </div>
            <div [hidden]="!error403">
                <div class="access-notification-container">
                    <h1 class="access-notification-title">
						<span class="fa access-denied-icon">&#xf023;</span> <span jhiTranslate="global.error.access.denied">Access Denied</span>
                    </h1>
                    <p jhiTranslate="global.error.access.denied.message">This functionality is restricted. See your administrator for additional permissions.</p>
                </div>
            </div>
        </div>
    </div>
</div>
